import React, { useState, useCallback } from 'react';
import DOMPurify from 'dompurify';
import SelectionChatWindow from './SelectionChatWindow';

const ReadPaperView = ({ isLoadingHtml, paperHtml, currentPaper }) => {
    const [selection, setSelection] = useState({
        text: '',
        position: { x: 0, y: 0 },
        isVisible: false
    });

    const handleTextSelection = useCallback(() => {
        const selectedText = window.getSelection().toString().trim();

        if (selectedText) {
            const range = window.getSelection().getRangeAt(0);
            const rect = range.getBoundingClientRect();

            setSelection({
                text: selectedText,
                position: {
                    x: rect.right + 10,
                    y: rect.top
                },
                isVisible: true
            });
        }
    }, []);

    const handleCloseChatWindow = useCallback(() => {
        setSelection(prev => ({ ...prev, isVisible: false }));
    }, []);

    return (
        <div className="h-full overflow-y-auto p-6 bg-black relative">
            {isLoadingHtml ? (
                <div className="flex items-center justify-center h-full">
                    <div className="flex flex-col items-center gap-4">
                        <div className="w-8 h-8 border-4 border-purple-600 border-t-transparent rounded-full animate-spin" />
                        <p className="text-gray-400">Loading paper content...</p>
                    </div>
                </div>
            ) : paperHtml ? (
                <>
                    <div className="absolute top-6 right-6 text-sm text-purple-400 bg-gradient-to-r from-gray-800/70 to-gray-700/50 px-3 py-1.5 rounded-md flex items-center gap-2 shadow-lg border border-gray-700/50">
                        <svg
                            className="w-4 h-4 text-purple-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>
                        <span>Select text to chat</span>
                    </div>
                    <div
                        className="max-w-4xl mx-auto prose prose-invert prose-purple paper-content"
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(paperHtml)
                        }}
                        style={{
                            '--tw-prose-invert-headings': '#fff',
                            '--tw-prose-invert-body': '#d1d5db',
                        }}
                        onMouseUp={handleTextSelection}
                    />
                    {selection.isVisible && (
                        <SelectionChatWindow
                            selectedText={selection.text}
                            position={selection.position}
                            onClose={handleCloseChatWindow}
                            currentPaper={currentPaper}
                        />
                    )}
                </>
            ) : (
                <div className="text-center text-gray-400">
                    <p>No content available</p>
                </div>
            )}
        </div>
    );
};

export default ReadPaperView; 